import React, { FC } from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';
import './loading-spinner-style.css'


interface LoadingSpinnerProps { 
  show: boolean 
}


const LoadingSpinner: FC<LoadingSpinnerProps> = ({ show }) => {
  if (!show) return null;

  return (
    <div 
      className={'overlay-fixed position-center flex align-items-center justify-content-center background-loading'} 
      role="status" 
      aria-live="polite" 
      aria-label="Caricamento"
    >
      <div className="hex-loader" aria-hidden="true">
        <svg className="hex" viewBox="-60 -52 120 104" fill="none">
          {/* Traccia di fondo */}
          <polygon className="track"
            points="50,0 25,43.301 -25,43.301 -50,0 -25,-43.301 25,-43.301"/>
            
          {/* Segmento animato */}
          <polygon className="dash"
            points="50,0 25,43.301 -25,43.301 -50,0 -25,-43.301 25,-43.301"/>
        </svg>
      </div>
    </div>
  );
};

export default LoadingSpinner;